import type { ExpansionPackDefinition, GrowthPackDefinition } from '../../../domain/industry/types';
import { buildPack, PACK_CONTENT } from './packBuilder';

const growthPacks: GrowthPackDefinition[] = [
  {
    id: 'fintech_growth_starter',
    industryId: 'fintech',
    tier: 1,
    name: 'Starter Banking',
    description: 'Core deposit products and KYC mission path.',
    unlocks: {
      productIds: ['fin_checking', 'fin_savings'],
      missionIds: ['fin_mission_kyc'],
      scenarioIds: ['fin_neobank_launch'],
    },
  },
  {
    id: 'fintech_growth_payments',
    industryId: 'fintech',
    tier: 2,
    name: 'Payments & Lending',
    description: 'Unlock P2P and consumer lending after AML fundamentals.',
    unlockConditions: { completedMissionIds: ['fin_mission_kyc'], minCompliance: 55 },
    unlocks: {
      productIds: ['fin_payments', 'fin_lending'],
      missionIds: ['fin_mission_aml'],
      scenarioIds: ['fin_pci_crisis'],
    },
  },
  {
    id: 'fintech_growth_scale',
    industryId: 'fintech',
    tier: 3,
    name: 'Scale & Cards',
    description: 'High-risk products after AML triage mastery.',
    unlockConditions: { completedMissionIds: ['fin_mission_aml'], minBudget: 5000 },
    unlocks: {
      productIds: ['fin_crypto', 'fin_cards'],
      missionIds: ['fin_mission_pci'],
    },
  },
];

const expansionPacks: ExpansionPackDefinition[] = [
  {
    id: 'fintech_exp_digital_assets',
    industryId: 'fintech',
    name: 'Digital Assets Desk',
    version: '1.0.0',
    description: 'Adds advanced crypto trading scenario focus and card-network pressure.',
    requiresGrowthTierId: 'fintech_growth_scale',
    adds: {
      frameworkIds: ['aml_kyc', 'pci_dss'],
    },
  },
];

export const fintechPack = buildPack({
  id: 'fintech',
  ...PACK_CONTENT.fintech,
  growthPacks,
  expansionPacks,
});